// src/pages/customer/Home.jsx
import React, { useEffect, useState, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getBanners, getCategories, getHomeProducts, getBlogs, getTestimonials, getFaqs, getFaqIllustration } from "../../services/firestoreService";
import { format } from "date-fns";
import ProductCard from "../../components/customer/ProductCard";
import Spinner from "../../components/common/Spinner";
import { FiArrowRight, FiTruck, FiShield, FiStar, FiPhone, FiChevronLeft, FiChevronRight, FiUser, FiCalendar } from "react-icons/fi";
import leafBg from "../../assests/background.png";
import faqImage from "../../assests/logo3.jpeg";

const FALLBACK_BANNERS = [
  { id: 1, title: "Fresh From the Farm", subtitle: "Quality agro products delivered to your door", image: "", ctaText: "Shop Now", ctaLink: "/products", bgColor: "#1b4332" },
  { id: 2, title: "100% Organic", subtitle: "Certified organic produce for a healthier life", image: "", ctaText: "Explore", ctaLink: "/products", bgColor: "#2d6a4f" },
];



function BannerSlide({ banner }) {
  return (
    <div
      className="relative w-full overflow-hidden banner-slide aspect-[10/5] md:aspect-[15/5.5]"
      style={{
        borderRadius: "16px",
        // border: "2.5px solid #4a6e30",
        boxShadow: "0 2px 16px 0 rgba(60,90,30,0.10)",
      // aspectRatio: "16/5.5",
      }}
    >
      {banner.image ? (
        <img
          src={banner.image}
          alt={banner.title}
          className="absolute inset-0 w-full h-full object-fill"
        />
      ) : (
        <div className="absolute inset-0 w-full h-full" style={{ background: banner.bgColor || "#1b4332" }} />
      )}
    </div>
  );
}

function TestimonialsSection({ testimonials }) {
  if (!testimonials || testimonials.length === 0) return null;

  const sliderRef = React.useRef(null);

  const settings = {
    dots: false,
    infinite: testimonials.length > 3,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, infinite: testimonials.length > 2 } },
      { breakpoint: 640,  settings: { slidesToShow: 1, infinite: testimonials.length > 1 } },
    ],
  };

  const StarRow = ({ count }) => (
    <div className="flex items-center justify-center gap-0.5 mb-3">
      {[1, 2, 3, 4, 5].map((n) => (
        <FiStar
          key={n}
          className="w-4 h-4 sm:w-5 sm:h-5"
          style={{
            color: n <= count ? "#f5c518" : "#d8d8c0",
            fill: n <= count ? "#f5c518" : "none",
          }}
        />
      ))}
    </div>
  );

  const avgRating = (
    testimonials.reduce((sum, t) => sum + (t.star || 0), 0) / testimonials.length
  ).toFixed(2);

  return (
    <section className="py-12 sm:py-16 relative overflow-hidden" style={{ background: "#f7f3e3" }}>
      {/* Decorative leaf branch background */}
      <img
        src={leafBg}
        alt=""
        aria-hidden="true"
        className="absolute -top-10 -right-10 w-[420px] sm:w-[560px] pointer-events-none select-none"
        style={{ opacity: 0.12, zIndex: 0 }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" style={{ zIndex: 1 }}>

        {/* Header: average rating */}
      <div className="flex flex-col items-center justify-center mb-8 sm:mb-12">
  <h2
    style={{
  fontFamily: "var(--custom-body-font-family)" ,
      fontSize: "clamp(1.8rem, 4vw, 2.8rem)",
      fontWeight: 800,
      color: "#2d3a1e",
      letterSpacing: "-0.5px",
      marginBottom: "10px",
    }}
  >
    Testimonial
  </h2>

  <div className="flex items-center justify-center gap-2">
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <FiStar
          key={n}
          className="w-5 h-5 sm:w-6 sm:h-6"
          style={{
            color: n <= Math.round(avgRating) ? "#f5c518" : "#d8d8c0",
            fill: n <= Math.round(avgRating) ? "#f5c518" : "none",
          }}
        />
      ))}
    </div>

    <span
      className="font-extrabold text-sm sm:text-base"
      style={{ color: "#2d3a1e" }}
    >
      {avgRating} ★
    </span>

    <span
      className="text-sm sm:text-base"
      style={{ color: "#5a6e40" }}
    >
      ({testimonials.length})
    </span>
  </div>
</div>

        {/* Slider with side arrows */}
        <div className="relative testimonial-slider px-8 sm:px-12">
          <button
            onClick={() => sliderRef.current?.slickPrev()}
            aria-label="Previous testimonials"
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center transition-all hover:opacity-70"
            style={{ color: "#3d4a2e" }}
          >
            <FiChevronLeft className="w-6 h-6 sm:w-7 sm:h-7" />
          </button>

          <Slider ref={sliderRef} {...settings}>
            {testimonials.map((t) => (
              <div key={t.id} className="px-2 sm:px-3">
                <div
                  className="text-center h-full"
                  style={{
                    background: "#eceadb",
                    borderRadius: "14px",
                    padding: "28px 22px",
                  }}
                >
                  <div
                    className="w-14 h-14 sm:w-16 sm:h-16 rounded-full mx-auto mb-3 flex items-center justify-center overflow-hidden flex-shrink-0"
                    style={{ background: "#d9e3c8", border: "2px solid #fff", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
                  >
                    {t.image ? (
                      <img src={t.image} alt={t.name} className="w-full h-full object-cover" />
                    ) : (
                      <FiUser className="w-6 h-6 sm:w-7 sm:h-7" style={{ color: "#5a6e40" }} />
                    )}
                  </div>
                  <p
                    className="font-bold mb-4 sm:mb-5 line-clamp-3"
                    style={{ color: "#1a2a0e", fontSize: "1rem", minHeight: "2.6em" }}
                  >
                    {t.comment}
                  </p>
                  <StarRow count={t.star || 0} />
                  <p className="font-bold text-sm sm:text-base" style={{ color: "#1a2a0e" }}>
                    {t.name}
                  </p>
                  {t.designation && (
                    <p className="text-xs sm:text-sm mt-0.5" style={{ color: "#7a8a68" }}>
                      {t.designation}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </Slider>

          <button
            onClick={() => sliderRef.current?.slickNext()}
            aria-label="Next testimonials"
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center transition-all hover:opacity-70"
            style={{ color: "#3d4a2e" }}
          >
            <FiChevronRight className="w-6 h-6 sm:w-7 sm:h-7" />
          </button>
        </div>

      </div>
    </section>
  );
}

function FAQSection({ faqs }) {
  const [open, setOpen] = useState(null);

  // Firestore FAQs use { question, answer }; normalize to { q, a }
  const list = (faqs || []).map((f) => ({ q: f.question, a: f.answer }));

  return (
    <section className="py-4 sm:py-20 overflow-hidden" style={{ background: "#f6f5f1" }}>
      <div className="px-4 sm:px-6 lg:px-8 mb-2 sm:mb-2">
        <span
          className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3"
          style={{ background: "#e8f0df", color: "#4a6e30" }}
        >
          ❓ Got Questions?
        </span>
        <h2
          className="text-2xl sm:text-4xl font-extrabold"
          style={{ color: "#2d4a1e" }}
        >
          FAQ's
        </h2>
        <p className="text-sm sm:text-base mt-2 max-w-xl" style={{ color: "#5a6e40" }}>
          Quick answers to the questions we hear most from our customers.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row items-start lg:items-center">

        {/* Left: FAQ accordion — has its own padding so it doesn't touch the image or the left edge */}
        <div className="w-full lg:w-[60%] px-4 sm:px-6 lg:pl-8 lg:pr-10 xl:pr-16 order-2 lg:order-1">
          <div className="flex flex-col gap-3">
            {list.map((faq, i) => (
              <div key={i} className="overflow-hidden" style={{ borderRadius: "10px" }}>
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between px-3 sm:px-3 py-3 sm:py-3 text-left font-bold text-sm sm:text-base transition-all"
                  style={{
                    background: open === i ? "#3d5c28" : "#4a6e30",
                    color: "#fff",
                    borderRadius: open === i ? "10px 10px 0 0" : "10px",
                  }}
                >
                  <span className="pr-4">{faq.q}</span>
                  <span
                    className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-lg font-bold transition-all"
                    style={{ background: "rgba(255,255,255,0.18)", color: "#fff" }}
                  >
                    {open === i ? "−" : "+"}
                  </span>
                </button>
                {open === i && (
                  <div
                    className="px-5 sm:px-6 py-4 sm:py-5 text-sm sm:text-base leading-relaxed"
                    style={{ background: "#fff", color: "#3d4a2e", borderRadius: "0 0 10px 10px", borderTop: "none" }}
                  >
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Right: illustration — has right padding so it doesn't touch the screen edge */}
        <div
          className="w-full lg:w-[40%] flex-shrink-0 mb-8 lg:mb-0 order-1 lg:order-2 flex items-center justify-center px-4 sm:px-6 lg:pr-8 xl:pr-12"
          style={{ background: "#f6f5f1" }}
        >
          <img
            src={faqImage}
            alt="Tripura Agro"
            className="w-full h-[320px] sm:h-[420px] lg:h-[480px] object-contain object-center select-none rounded-xl"
          />
        </div>

      </div>
    </section>
  );
}


export default function Home() {
  const [banners,       setBanners]       = useState([]);
  const [categories,    setCategories]    = useState([]);
  const [allFeatured,   setAllFeatured]   = useState([]);   // full list from Firestore
  const [activeCategory, setActiveCategory] = useState("all"); // "all" | category.id
  const [loading,       setLoading]       = useState(true);
  const [blogs,         setBlogs]         = useState([]);
  const [testimonials,  setTestimonials]  = useState([]);
  const [faqs,          setFaqs]          = useState([]);
  const [faqIllustration, setFaqIllustration] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const [b, c, p, bl, ts, fq, fi] = await Promise.all([
          getBanners(),
          getCategories(),
          getHomeProducts(),   // ← fetches ALL products, featured sorted first
          getBlogs(true),
          getTestimonials(),
          getFaqs().catch((err) => { console.error("getFaqs failed:", err); return []; }),
          getFaqIllustration().catch((err) => { console.error("getFaqIllustration failed:", err); return null; }),
        ]);
        setBanners(b.length ? b : FALLBACK_BANNERS);
        setCategories(c.slice(0, 8));
        setAllFeatured(p);
        setBlogs(bl.slice(0, 3));
        setTestimonials(ts);
        setFaqs(fq);
        setFaqIllustration(fi);
      } catch (err) {
        console.error(err);
        setBanners(FALLBACK_BANNERS);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Filter products by active category tab
  const featured = useMemo(() => {
    const list =
      activeCategory === "all"
        ? allFeatured
        : allFeatured.filter((p) => p.categoryId === activeCategory);
    return list.slice(0, 8);
  }, [allFeatured, activeCategory]);

  // Category tabs show ALL categories from Firestore (not filtered by product presence)
  // so all 4 categories always appear even if some have no products yet
  const featuredCategoryIds = useMemo(
    () => new Set(allFeatured.map((p) => p.categoryId).filter(Boolean)),
    [allFeatured]
  );
  const categoryTabs = useMemo(
    () => categories,   // ← show ALL categories, not just those with products
    [categories]
  );

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <div>
      <Helmet>
        <title>Tripura Agro</title>
        <meta
          name="description"
          content="Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level and the final customer, who may be an individual or an institution."
        />
      </Helmet>
      <section className="pt-3 sm:pt-5 pb-2" style={{ background: "#f7f3e3" }}>
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
          {loading ? (
            <div className="w-full h-full animate-pulse " style={{ aspectRatio: "16/6", borderRadius: "16px", background: "#e8e8d8" }} />
          ) : banners.length === 1 ? (
            <BannerSlide banner={banners[0]} />
          ) : banners.length > 1 ? (
            <div className="hero-slider">
              <Slider {...sliderSettings}>
                {banners.map((banner) => (
                  <div key={banner.id}><BannerSlide banner={banner} /></div>
                ))}
              </Slider>
            </div>
          ) : null}
        </div>
      </section>

      <style>{`
        body :where(p, a, span, small, li, label, legend, summary, button, input, textarea, select, option, table, thead, tbody, tfoot, tr, th, td, caption, blockquote, cite, em, strong, b, i, div, .button, .btn, .field__input, .form__label, .product-form__submit, .price, .badge, .card__information, .product__text, .header__menu-item, .menu-drawer__menu-item, .footer-block, .rte):not(.jdgm-widget):not(.jdgm-widget *):not([class*="jdgm"]):not([class*="jdgm"] *):not(.spr-container):not(.spr-container *):not(.icon):not(.icon *):not([class^="icon-"]):not([class*=" icon-"]):not([class*="fa-"]):not([class*="fa-"] *):not(svg):not(svg *):not(path):not(path *) {
          font-family: var(--custom-body-font-family) !important;
          font-weight: 700 !important;
          font-style: normal !important;
        }
        .hero-slider .slick-slider { position: relative; display: block; }
        .hero-slider .slick-list { position: relative; display: block; overflow: hidden; margin: 0; padding: 0; }
        .hero-slider .slick-track { position: relative; top: 0; left: 0; display: flex !important; }
        .hero-slider .slick-slide { display: none; float: left; height: 100%; min-height: 1px; }
        .hero-slider .slick-initialized .slick-slide { display: block !important; }
        .hero-slider .slick-slide > div { line-height: 0; }
        .hero-slider .slick-dots { position: absolute !important; bottom: 12px !important; left: 0; right: 0; width: 100%; display: flex !important; align-items: center; justify-content: center; gap: 6px; list-style: none; margin: 0; padding: 0; z-index: 20; }
        .hero-slider .slick-dots li { width: auto !important; height: auto !important; margin: 0 !important; padding: 0 !important; }
        .hero-slider .slick-dots li button { width: 8px !important; height: 8px !important; padding: 0 !important; border: 1.5px solid rgba(255,255,255,0.85) !important; border-radius: 9999px !important; background: transparent !important; font-size: 0; line-height: 0; cursor: pointer; transition: all 0.3s ease; }
        .hero-slider .slick-dots li button::before { content: none !important; }
        .hero-slider .slick-dots li.slick-active button { width: 24px !important; background: #15803d !important; border-color: #ffffff !important; }
        .category-scroll::-webkit-scrollbar { display: none; }
        .testimonial-slider .slick-slider { position: relative; display: block; }
        .testimonial-slider .slick-list { position: relative; display: block; overflow: hidden; margin: 0; padding: 0; }
        .testimonial-slider .slick-track { position: relative; top: 0; left: 0; display: flex !important; }
        .testimonial-slider .slick-slide { display: none; float: left; height: auto; min-height: 1px; }
        .testimonial-slider .slick-slide > div { height: 100%; }
        .testimonial-slider .slick-initialized .slick-slide { display: block !important; }
       
        @media (min-width: 640px) {
          .hero-slider .slick-dots { bottom: 20px !important; gap: 8px; }
          .hero-slider .slick-dots li button { width: 10px !important; height: 10px !important; }
          .hero-slider .slick-dots li.slick-active button { width: 32px !important; }
        }
      `}</style>
      <section className="py-10 sm:py-16 relative overflow-hidden" style={{ background: "#f5f5e8" }}>
        {/* Decorative leaf branch background — sits behind the product cards, not the header */}
        <img
          src={leafBg}
          alt=""
          aria-hidden="true"
          className="absolute bottom-0 -left-16 w-[420px] sm:w-[560px] pointer-events-none select-none"
          style={{ opacity: 0.12, zIndex: 0 }}
        />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" style={{ zIndex: 1 }}>

          {/* Centered header */}
          <div className="text-center mb-6 sm:mb-10">
            <h2
              className="text-2xl sm:text-4xl md:text-5xl font-extrabold mb-1 sm:mb-2"
              style={{ color: "#2d4a1e", fontFamily: "var(--custom-body-font-family)" }}
            >
              Featured Products
            </h2>
            <p className="text-sm sm:text-base font-semibold" style={{ color: "#4a6e30" }}>
              Shop By Categories
            </p>
          </div>

          {/* ── Category pills – always a single scrollable row, never wraps ── */}
          {categoryTabs.length > 0 && (
            <div
              className="category-scroll flex items-center gap-2 sm:gap-3 mb-8 sm:mb-12 flex-nowrap"
              style={{
                overflowX: "auto",
                WebkitOverflowScrolling: "touch",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                paddingBottom: "4px",
              }}
            >

              {/* Bestseller / All pill – active style = filled green oval with image */}
              <button
                onClick={() => setActiveCategory("all")}
                className="flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2 sm:py-3 transition-all duration-300 font-bold text-sm sm:text-base flex-shrink-0"
                style={{
                  borderRadius: "999px",
                  border: activeCategory === "all" ? "2px solid #4a6e30" : "2px solid #c8c8b0",
                  background: activeCategory === "all" ? "#4a6e30" : "#fff",
                  color: activeCategory === "all" ? "#fff" : "#4a4a30",
                  boxShadow: activeCategory === "all" ? "0 4px 14px #4a6e3044" : "none",
                }}
              >
                <span className="w-7 h-7 sm:w-9 sm:h-9 rounded-full flex items-center justify-center text-base sm:text-lg flex-shrink-0"
                  style={{ background: activeCategory === "all" ? "rgba(255,255,255,0.2)" : "#f0efe0" }}>
                  🌾
                </span>
                <span>Bestseller</span>
              </button>

              {categoryTabs.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className="flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2 sm:py-3 transition-all duration-300 font-bold text-sm sm:text-base flex-shrink-0"
                  style={{
                    borderRadius: "999px",
                    border: activeCategory === cat.id ? "2px solid #4a6e30" : "2px solid #c8c8b0",
                    background: activeCategory === cat.id ? "#4a6e30" : "#fff",
                    color: activeCategory === cat.id ? "#fff" : "#4a4a30",
                    boxShadow: activeCategory === cat.id ? "0 4px 14px #4a6e3044" : "none",
                  }}
                >
                  {cat.image ? (
                    <img
                      src={cat.image}
                      alt={cat.name}
                      className="w-7 h-7 sm:w-9 sm:h-9 rounded-full object-cover flex-shrink-0"
                      style={{ border: activeCategory === cat.id ? "2px solid rgba(255,255,255,0.5)" : "2px solid #e0e0cc" }}
                    />
                  ) : (
                    <span className="w-7 h-7 sm:w-9 sm:h-9 rounded-full flex items-center justify-center text-base flex-shrink-0"
                      style={{ background: activeCategory === cat.id ? "rgba(255,255,255,0.2)" : "#f0efe0" }}>
                      🌿
                    </span>
                  )}
                  <span className="whitespace-nowrap">{cat.name}</span>
                </button>
              ))}
            </div>
          )}

          {/* Product grid */}
          {loading ? (
            <div className="flex items-center justify-center py-20"><Spinner center /></div>
          ) : featured.length === 0 ? (
            <div className="text-center py-20 bg-white rounded-3xl border border-gray-100">
              <div className="w-24 h-24 mx-auto rounded-full bg-green-50 flex items-center justify-center text-5xl mb-6">🌱</div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">No Products Found</h3>
              <p className="text-gray-500 text-sm">No featured products in this category yet.</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5 lg:gap-6">
              {featured.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          )}

          {featured.length > 0 && (
            <div className="flex justify-center mt-8 sm:mt-12">
              <Link
                to="/products"
                className="inline-flex items-center gap-2 px-8 sm:px-14 py-3 sm:py-4 rounded-full font-bold text-sm sm:text-base transition-all hover:opacity-90 hover:-translate-y-0.5 shadow-md hover:shadow-lg"
                style={{ background: "#4a6e30", color: "#fff" }}
              >
                View More
              </Link>
            </div>
          )}

        </div>
      </section>

      {/* ── FAQ Section — hidden entirely until the admin adds at least one FAQ ── */}
      {faqs.length > 0 && <FAQSection faqs={faqs} />}

      {/* ── Testimonials Section ── */}
      <TestimonialsSection testimonials={testimonials} />

      {blogs.length > 0 && (
        <section className="py-12 sm:py-16 relative overflow-hidden" style={{ background: "#f7f3e3" }}>
          {/* Decorative leaf branch background */}
          <img
            src={leafBg}
            alt=""
            aria-hidden="true"
            className="absolute -bottom-16 -left-16 w-[420px] sm:w-[560px] pointer-events-none select-none"
            style={{ opacity: 0.12, zIndex: 0, transform: "scaleX(-1)" }}
          />

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" style={{ zIndex: 1 }}>

            {/* Header */}
            <div className="text-center mb-8 sm:mb-12">
              <h2
                style={{
                  fontFamily: "var(--custom-body-font-family)" ,
                  fontSize: "clamp(1.8rem, 4vw, 2.8rem)",
                  fontWeight: 800,
                  color: "#2d3a1e",
                  letterSpacing: "-0.5px",
                  marginBottom: "6px",
                }}
              >
                Recent Blogs
              </h2>
              <p
                style={{
                   fontFamily: "var(--custom-body-font-family)" ,
                  fontSize: "clamp(0.82rem, 1.5vw, 1rem)",
                  fontStyle: "italic",
                  color: "#5a6e40",
                  fontWeight: 400,
                }}
              >
                Fresh stories, recipes and purity tips from Tripura Agro
              </p>
            </div>

            {/* Cards grid — same card design as the Blog listing page */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-7">
              {blogs.map((blog) => (
                <Link
                  key={blog.id}
                  to={`/blog/${blog.id}`}
                  className="group flex flex-col rounded-2xl overflow-hidden bg-white shadow-sm
                             hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
                >
                  {/* Thumbnail */}
                  <div className="aspect-[16/9] overflow-hidden bg-primary-50">
                    {blog.image ? (
                      <img
                        src={blog.image}
                        alt={blog.title}
                        className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-400"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-5xl">📰</div>
                    )}
                  </div>

                  {/* Body */}
                  <div className="flex flex-col flex-1 p-5">
                    {blog.category && (
                      <span className="text-[11px] font-semibold text-primary-600 uppercase tracking-widest mb-1.5">
                        {blog.category}
                      </span>
                    )}
                    <h3 className="font-semibold text-gray-900 text-base leading-snug line-clamp-3 mb-2
                                   group-hover:text-primary-600 transition-colors flex-1">
                      {blog.title}
                    </h3>
                    <p className="text-sm text-gray-400 line-clamp-3 mb-4 leading-relaxed">
                      {blog.excerpt || blog.content?.replace(/<[^>]+>/g, "").slice(0, 110)}
                    </p>

                    {/* Footer row */}
                    <div className="flex items-center justify-between text-[11px] text-gray-400 pt-3
                                    border-t border-gray-100 mt-auto">
                      <div className="flex items-center gap-3">
                        {blog.author && (
                          <span className="flex items-center gap-1"><FiUser className="w-3 h-3" /> {blog.author}</span>
                        )}
                        {blog.createdAt?.toDate && (
                          <span className="flex items-center gap-1">
                            <FiCalendar className="w-3 h-3" />
                            {format(blog.createdAt.toDate(), "dd MMM yyyy")}
                          </span>
                        )}
                      </div>
                      <span className="flex items-center gap-1 text-primary-600 font-semibold
                                       group-hover:gap-2 transition-all">
                        Read <FiArrowRight className="w-3 h-3" />
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* View All Blogs button */}
            <div className="flex justify-center mt-10 sm:mt-14">
              <Link
                to="/blog"
                className="inline-flex items-center gap-2 font-bold transition-all hover:opacity-90 hover:-translate-y-0.5"
                style={{
                  background: "#4a6e30",
                  color: "#fff",
                  borderRadius: "999px",
                  padding: "14px 52px",
                  fontSize: "0.95rem",
                  boxShadow: "0 4px 16px rgba(74,110,48,0.25)",
                }}
              >
                View All Blogs
              </Link>
            </div>

          </div>
        </section>
      )}

     
    </div>
  );
}